import { Flex } from "antd";
import type { HTMLAttributes, PropsWithChildren } from "react";

type FilterBarProps = HTMLAttributes<HTMLDivElement>;

export const FilterBar = ({
  children,
  className,
  style,
  ...rest
}: PropsWithChildren<FilterBarProps>) => (
  <Flex vertical gap={16} className={className} style={{ width: "100%", ...style }} {...rest}>
    {children}
  </Flex>
);

type FilterRowProps = HTMLAttributes<HTMLDivElement>;

export const FilterRow = ({
  children,
  className,
  style,
  ...rest
}: PropsWithChildren<FilterRowProps>) => (
  <Flex
    gap={16}
    wrap="wrap"
    align="center"
    className={className}
    style={{ width: "100%", ...style }}
    {...rest}
  >
    {children}
  </Flex>
);
